import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { HashRouter, BrowserRouter } from "react-router-dom";
import { initializeApp } from "firebase/app";
import {
  getAuth,
  signInWithEmailAndPassword,
  signOut,
  createUserWithEmailAndPassword,
} from "firebase/auth";
import "bootstrap/dist/css/bootstrap.min.css";
import { UserProvider } from "./UserContext";
import "./i18n";
import i18n from "i18next";
import axios from "axios";
import { getDatabase } from "firebase/database";
import { getMessaging } from "firebase/messaging";

document.documentElement.lang = "ar";
document.documentElement.dir = "rtl";

i18n.on("languageChanged", (lng) => {
  console.log(lng);
  document.documentElement.lang = lng; // Update the lang attribute
  document.documentElement.dir = lng === "ar" ? "rtl" : "ltr"; // Update the dir attribute
});
// development api
// axios.defaults.baseURL = "http://34.31.12.216/egrocare-api/egrocare/";
// axios.defaults.baseURL = "https://egybots.com/egrocare-api/egrocare/";

// local api
// axios.defaults.baseURL = "http://localhost:8080/";

// production api
axios.defaults.baseURL = "https://egrobots.com/egrocare-api/egrocare/";
// axios.defaults.baseURL = "https://egrobots.com/awn-api/awn/";

// Development egrocare firebase project
// const firebaseConfig = {
//   apiKey: "AIzaSyCCrmoK-jdBnVjGq5l6sJjUnN-O6tfKhus",
//   authDomain: "egro-care-dev.firebaseapp.com",
//   databaseURL: "https://egro-care-dev-default-rtdb.firebaseio.com",
//   projectId: "egro-care-dev",
//   storageBucket: "egro-care-dev.appspot.com",
//   messagingSenderId: "680373422737",
//   appId: "1:680373422737:web:a84fe49f9b95a665608d30",
//   measurementId: "G-M67NJL6QE7",
// };

// Development awn firebase project
// const firebaseConfig = {
//   apiKey: "AIzaSyBPqazUVNAfEc-VfazTowRZnWXTETWB88Q",
//   authDomain: "aawn-dev-74d4b.firebaseapp.com",
//   projectId: "aawn-dev-74d4b",
//   storageBucket: "aawn-dev-74d4b.firebasestorage.app",
//   messagingSenderId: "446935932888",
//   appId: "1:446935932888:web:8fa98a650b0cdf61639cad",
//   measurementId: "G-5P4S8WK6XD",
// };

// Production awn firebase project
// const firebaseConfig = {
//   apiKey: "AIzaSyCUzJ3vxJ_x8pniVLAK4LxL9YXWb2pxuz0",
//   authDomain: "aawn-85298.firebaseapp.com",
//   projectId: "aawn-85298",
//   storageBucket: "aawn-85298.firebasestorage.app",
//   messagingSenderId: "563201219004",
//   appId: "1:563201219004:web:cc7a889cb334796a8533b9",
//   measurementId: "G-LS6PBWPENL",
// };

// Production egrocare firebase project
const firebaseConfig = {
  apiKey: "AIzaSyAlY9kbHhOr27CaiKB__N44cNy41ZesWCE",
  authDomain: "egro-care.firebaseapp.com",
  databaseURL: "https://egro-care-default-rtdb.firebaseio.com",
  projectId: "egro-care",
  storageBucket: "egro-care.appspot.com",
  messagingSenderId: "893543959837",
  appId: "1:893543959837:web:3628a907f270a2ffdce5f4",
  measurementId: "G-BW8HYPYPDY",
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(); // Get auth instance
const db = getDatabase();
const messaging = getMessaging(app); // Initialize messaging
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
  //   <App />
  // </React.StrictMode>
  <UserProvider>
    <App />
  </UserProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
export {
  auth,
  signInWithEmailAndPassword,
  signOut,
  createUserWithEmailAndPassword,
  db,
};
